<template>
    <div class="page bg-gray pb-navs">
        <backTitleBar :rightEle="rightEle"></backTitleBar>
        <div class="home-main">
            <div class="flex-center">
                <div class="flex1">
                    <div class="name">{{entity.shopName}}</div>
                    <div class="color-999 fs-28">{{entity.address}}</div>
                </div>
                <div class="right-time text-center click" @click="openPicker">
                    <div class="alifont icon-bianzu color-999" style="font-size: .4rem"></div>
                    <div class="fs-28 color-999">{{showDateValue}}</div>
                </div>
            </div>
            <div class="mt-30">
                <span class="color-999 fs-28">销量金额</span>
                <span class="ml-10 number_font money">{{formatNumber(countEntity.salesCount|| 0)}}</span>

                <span class="color-999 fs-28" style="margin-left: 20px">柜内货价</span>
                <span class="ml-10 number_font money">{{formatNumber(Number(countEntity.stockAmount || 0).toFixed(2))}}</span>

            </div>
        </div>
        <div class="card number-count">
            <div class="flex">
                <div class="left flex1 ">
                    <div class="f1 number_font">{{formatNumber(countEntity.openDoorCount || 0)}}</div>
                    <div class="fs-28 color-999">开门次数</div>
                </div>
                <div class="right flex1">
                    <div class="f1 number_font">{{formatNumber(countEntity.buyUserCount || 0)}}</div>
                    <div class="fs-28 color-999">购买用户数</div>
                </div>
            </div>
            <div class="flex mt-25">
                <div class="left flex1">
                    <div class="f1 number_font">{{formatNumber(countEntity.orderCount || 0)}}</div>
                    <div class="fs-28 color-999">订单数</div>
                </div>
                <div class="right flex1">
                    <div class="f1 number_font">{{formatNumber(countEntity.itemCount || 0)}}</div>
                    <div class="fs-28 color-999">商品销售数</div>
                </div>
            </div>
        </div>

        <div class="card" style="margin-top: -.8rem">
            <div class="card-title">
                商品销售榜
            </div>
            <div class="card-tab">
                <div class="tab-item" :class="tabActive == item.value ?'active':''" v-for="item in tabList" :key="item.value" @click="tabActive = item.value">{{item.name}}</div>
            </div>
            <div v-show="tabActive == 1">
                <div class="card-table-header">
                    <div class="table-index">排行</div>
                    <div class="table-main">商品名称</div>
                    <div class="table-number">数量</div>
                </div>
                <ul >
                    <li class="li-item" v-for="(item,$index) in saleList" :key="$index">
                        <div class="table-index">{{$index + 1}}</div>
                        <div class="table-main">{{item.productName}}</div>
                        <div class="table-number">
                            <span v-if="item.isWeightCalc != 1">{{item.quantity}}</span>
                            <span v-if="item.isWeightCalc == 1">{{item.quantity/1000}}kg</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-show="tabActive == 2">
                <div class="card-table-header">
                    <div class="table-index">排行</div>
                    <div class="table-main">商品名称</div>
                    <div class="table-number">金额</div>
                </div>
                <ul >
                    <li class="li-item" v-for="(item,$index) in amountList" :key="$index">
                        <div class="table-index">{{$index + 1}}</div>
                        <div class="table-main">{{item.productName}}</div>
                        <div class="table-number">{{Number(item.salesAmount || 0).toFixed(2)}}</div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="card" style="margin: .2rem .25rem">
            <div class="card-title">商品销售统计</div>
                <div class="card-table-header">
                <div class="table-index">排行</div>
                <div class="table-main">商品名称</div>
                <div class="table-number2">库存</div>
                <div class="table-number2">销量</div>
            </div>
            <ul>
                <li class="li-item" v-for="(item,$index) in stockList" :key="$index">
                    <div class="table-index">{{$index + 1}}</div>
                    <div class="table-main">{{item.productName}}</div>
                    <div class="table-number2">
                        <span v-if="item.isWeightCalc != 1">{{item.num}}</span>
                        <span v-if="item.isWeightCalc == 1">{{item.num/1000}}kg</span>
                    </div>
                    <div class="table-number2">
                        <span v-if="item.isWeightCalc != 1">{{item.saleNum || 0}}</span>
                        <span v-if="item.isWeightCalc == 1">{{(item.saleNum || 0)/1000}}kg</span>
                    </div>
                </li>
            </ul>
        </div>

        <navs :shopId="shopId"></navs>

        <van-popup v-model="popupShow" position="bottom">
            <van-datetime-picker v-model="selectValue" type="date" @confirm="handleConfirm" @cancel="handleCancel"/>
        </van-popup>

    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryShopDetail,qryShopInfoCount} from "@/api/shop"
    import navs from "./equipment-navs"
    import util from "@/utils/index"
    export default {
        name: "equipmentMain",
        components:{backTitleBar,navs},
        data(){
            return{
                rightEle:{
                    iconName:'icon-baojing',
                    color:'#333',
                    fontSize:'.6rem',
                    method: ''
                },
                tabList:[
                    {name:'按销量排行',value: 1},
                    {name:'按金额排行',value: 2},
                ],
                tabActive : 1,
                shopId:'',
                selectValue: new Date(),
                popupShow:false,
                entity:{},
                countEntity:{
                    itemCountList:[],
                    itemAmountList:[],
                    stockCountList:[]
                }
            }
        },
        computed:{
            'showDateValue':function(){
                return util.formatDate(this.selectValue,'MM-dd');
            },
            'dateValue':function () {
                return util.formatDate(this.selectValue,'yyyy-MM-dd');
            },
            'saleList': function () {
                return (this.countEntity.itemCountList || []).filter(function (number,index) {
                    return index < 5
                })
            },
            'amountList': function () {
                return (this.countEntity.itemAmountList || []).filter(function (number,index) {
                    return index < 5
                })
            },
            'stockList': function () {
                return this.countEntity.stockCountList || []
            },
        },
        created(){
            this.$store.state.showFooter = false;
            this.$store.state.shop_nav_value = 0;
            if(this.$route.query.shopId){
                this.shopId = this.$route.query.shopId;
            }
            this.getDetail();
            this.getCount();
        },
        mounted(){

        },
        methods:{
            openPicker() {
                this.popupShow = true;
            },
            handleConfirm(e){
                this.selectValue = e;
                this.getCount();
                this.handleCancel()
            },
            handleCancel(){
                this.popupShow = false
            },
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    this.entity = res.data;
                })
            },
            getCount(){
                let params = {
                    day : this.dateValue,
                    shopId : this.shopId
                }
                qryShopInfoCount(params).then(res=>{
                    this.countEntity = res.data || {};
                    if (!this.countEntity.itemCountList) {
                        this.$set(this.countEntity, 'itemCountList', [])
                    }
                    if (!this.countEntity.itemAmountList) {
                        this.$set(this.countEntity, 'itemAmountList', [])
                    }
                    if (!this.countEntity.stockCountList) {
                        this.$set(this.countEntity, 'stockCountList', [])
                    }
                })
            },
        }
    }
</script>



<style scoped lang="scss">

    .home-main{
        background: #3c415a;
        padding: .44rem .48rem 1.4rem .52rem;
        border-radius: 0 0 .5rem .5rem;
        .name{
            font-size: .4rem;
            color: #fff;
            font-weight: bold;
            line-height: .56rem;
        }
        .money{
            font-size: .54rem;
            line-height: .75rem;
            font-weight: bold;
            color: $main-color;
        }
        .right-time{
            padding: .2rem .25rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border: .02rem solid #919ba6;
            border-radius: .28rem;
        }
    }
    .number-count{
        position: relative;
        padding: .48rem 0;
        box-shadow:0px 0px .11rem 0px rgba(237,238,242,0.18);
        border-radius: .24rem;
        top: -1.1rem;
        margin: 0 .24rem;
        .left{
            position: relative;
            padding-left: .8rem;
            &::after{
                position: absolute;
                content: '';
                width: .02rem;
                height: .4rem;
                background: #D8D8D8;
                right: 0;
                top: .35rem;
            }
        }
        .right{
            padding-left: .8rem;
        }
        .f1{
            color: $org;
            font-size: .48rem;
            line-height: .67rem;
        }
    }

    .card{
        width: 7rem;
        margin: 0 .25rem;
        background: #fff;
        border-radius: .24rem;
        padding: .28rem .26rem;
        .card-title{
            font-size: .34rem;
            line-height: .48rem;
            color: #252D46;
            font-weight: bold;
            padding: 0;
            &:after{
                display: none;
            }
        }
        .card-tab{
            display: flex;
            margin-top: .2rem;
            padding-bottom: .2rem;
            .tab-item{
                margin-right: .5rem;
                font-size: .3rem;
                line-height: .45rem;
                color: #919BA6;
                &.active{
                    position: relative;
                    color: #252D46;
                    &:after{
                        position: absolute;
                        content: '';
                        width: .32rem;
                        height: .06rem;
                        background: $main-color;
                        border-radius: .03rem;
                        bottom: -.15rem;
                        left: 0;
                    }
                }
            }
        }
    }
    .card-table-header{
        margin-top: .25rem;
        display: flex;
        background: #F5F6FA;
        border-radius: .14rem;
        padding: .16rem .2rem;
        font-size: .28rem;
        line-height: .4rem;
        color: #666;
    }
    .table-index{
        width: .6rem;
        margin-right: .2rem;
    }
    .table-main{
        flex: 1;
        margin-right: .2rem;
    }
    .table-main{
        flex: 1;
        margin-right: .2rem;
    }
    .table-number{
        width: 1rem;
    }
    .table-number2{
        width: 1.2rem;
    }
    .li-item{
        display: flex;
        font-size: .32rem;
        line-height: .45rem;
        color: #333;
        padding: .15rem .2rem;
        .table-number{
            color: $org;
        }
    }
    .pb-navs{
        padding-bottom: 1.34rem;
    }
</style>



// WEBPACK FOOTER //
// equipmentHome.vue?67645378